import { createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';
import { ScheduleState } from '../reducers/schedule.reducer';

export const selectScheduleState = (state: AppState) => state.schedule;

export const selectScheduleUiSettings = createSelector(
  selectScheduleState,
  (state: ScheduleState) => state.scheduleUiSettings
);

export const selectScheduleUiSettingsLoading = createSelector(
  selectScheduleState,
  (state: ScheduleState) => state.scheduleUiSettingsLoading
);

export const selectScheduleUiSettingsError = createSelector(
  selectScheduleState,
  (state: ScheduleState) => state.scheduleUiSettingsError
);
